import { Input } from '@trackman/web-shared-components';
import ErrorInfo from 'components/ErrorInfo/ErrorInfo';
import { LocationType } from 'types/admin/trackmanEventsAdmin';
import { httpsUrlValidator } from 'utilities/urlValidators';

export const UrlInput = ({
  locationType,
  meetingUrl,
  setHasFormError,
  setMeetingUrlValue,
  error,
}: {
  locationType: LocationType;
  meetingUrl: string;
  error: boolean;
  setHasFormError: (hasError: boolean) => void;
  setMeetingUrlValue: (url: string) => void;
}) => {
  const handleOnChange = (newValue: string) => {
    const isError = !httpsUrlValidator(newValue);
    setHasFormError(isError);
    setMeetingUrlValue(newValue);
  };

  return (
    <div className='admin-edit-section'>
      <h2>{locationType === 'Online' && 'Teams'} URL*</h2>
      <div className='input-wrapper'>
        <Input
          label='URL'
          value={meetingUrl ?? ''}
          required
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e.currentTarget.value)}
          hint={error ? <ErrorInfo errorMsg='Please enter a valid URL starting with https://' /> : ' '}
          error={error}
        />
      </div>
    </div>
  );
};
